<template>
  <div class="huaxiang" style="padding-top:30px;">
    <!-- <FangziHeadTwo ttPass="企业画像"></FangziHeadTwo> -->
    <!-- <div style="padding: 20px 50px;overflow: hidden">
    </div> -->
    <div   style="text-align: center;">
      <div style="line-height: 80px;font-weight: 550;font-size:20px;color:#2E2E2E;">产业企业画像</div>
      <div   style="width: 800px;margin: 0 auto">
   
        <el-autocomplete
        style="width:660px"
    v-model.trim="state"
    :fetch-suggestions="querySearch"
    placeholder="请输入企业名称关键字"
    @select="handleSelect"
    clearable
    :disabled="!common.getSessionStorage('userInfo')"
  >
  <el-button slot="append" icon="el-icon-search"  @click="btnSearch" :disabled="isLoading"></el-button>
</el-autocomplete>
      </div>
    </div>
    <div style="margin: 50px 105px 0px;background: #fff;padding: 30px;" class="companys">
      <div   style="font-size: 12px">共检索到<span style="color:#1E90FF;">{{totalPassSY}}</span>家企业</div>
      <!-- <div class="list" v-for="(item,index) in gridDataShangyou" :key="index" @click="goxq(item.id)">
          <div class="h1">{{item.name}}</div>
          <div class="flex h2">
            <div class="flex-1">注册资本 ： {{ item.regAmount==-1?'暂无数据':item.regAmount+"万元" }}）</div>
            <div class="flex-1">成立时间 ： {{item.setupDate}}</div>
            <div class="flex-1">注册地址：{{item.address}}</div>
          </div>
      </div> -->
      <div style="border-top: 1px solid #eceff6;margin-top:10px;"> 

</div>

<el-row v-for="(item, index) in gridDataShangyou" :key="item.id" style="padding:10px 0;border-bottom: 1px solid #eceff6;">
               
               <el-col :span="2"
                 ><div
                   class="grid-content bg-purple-light"
                   
                 >
                   <el-image
                   v-if="item.logo!=''"
                     style="
                       width: 48px;
                       height: 48px;
                       margin-left: calc(50% - 24px);
                       margin-top: 0px;
                       border-radius: 5px;
                     "
                     :src="item.logo"
                     :fit="''"
                   >
                     <div slot="error" class="image-slot" style="position: relative;">
                       <el-image
                       style="
                       width: 48px;
                       height: 48px;
                       border-radius: 5px;
                      
                     "
                         :src="require('@/assets/img/map/lanse.png')"
                       >
                  
                     </el-image>
                     <div style="position: absolute;top:0;left:0;text-align: center;width:48px;font-size: 14px;color: white;margin-top: 4px;">
                       {{item.name.substr(0,2)}}<br />{{item.name.substr(2,2)}}
                     </div>
                     </div>
                   </el-image>
                     <div v-else style="position:relative;width:48px;height: 48px;margin-left: calc(50% - 24px);
                       margin-top: 0px; border-radius: 5px;" :style="'background-color:'+item.clCaihong+';'"> 
<div style="position: absolute;top:0;left:0;text-align: center;width:48px;font-size: 14px;color: white;margin-top: 4px;">
                       {{item.name.substr(0,2)}}<br />{{item.name.substr(2,2)}}
                     </div>
                     </div>
                   </div
               ></el-col>
               <el-col :span="22"
                 ><div class="z2_contents" >
                   <p class="pnomp pline">
                     <span class="pname" @click="goxq(item.id)">{{ item.name }}</span
                     ><span class="textml z2_infos" style="margin-left: 4px"
                       >
                       <el-tag v-if="item.regStatus==1 ||item.regStatus==''" type="success" size="mini">存续</el-tag>
                       <el-tag v-else type="danger" size="mini">注销</el-tag>
                       </span
                     >
                     <!-- <span
                       class="textml z2_infos textgr"
                       v-if="item.website != ''"
                       >官网</span
                     > -->
                   </p>
                   <p class="pnomp z2_infos textbl" style="min-height: 20px;font-size: 12px;">
                     <span
                       class="textml texttag"
                       v-for="item2 in item.labelList"
                       :key="item2"
                       >{{ item2 }}</span
                     >
                   </p>
                   <p class="pnomp z2_infos">
                     <span>法定代表人：<span class="mybl">{{ item.legalPerson }}</span></span
                     ><span class="textml2"
                       >注册资金：{{ item.regAmount=='-1'?0:item.regAmount }}(万元)</span
                     ><span class="textml2"
                       >成立时间：{{ item.setupDate }}</span
                     ><span class="textml2"
                       >统一社会信用代码：{{item.stockCode }}</span
                     >
                   </p>
                   <p class="pnomp z2_infos">
                     <span style="min-width:150px;display: inline-block;"
                       >电话：<span class="textbl gw"
                         >{{ item.phone }}</span
                       ></span
                     >
                   
                     <span class="ml8" style="min-width:180px;display: inline-block;"
                       >邮箱：</span
                     ><span class="textbl">{{ item.email }}</span
                     >
             
                     <span class="textml2">官网：</span
                       
                     ><span @click="gotoWOff" class="textbl gw">{{
                       item.website
                     }}</span>
                   </p>
                   <p class="pnomp z2_infos">
                     <span>地址：{{ item.address }}</span>
                   </p>

                   <p v-if="false" class="pnomp z2_infos ellipsis zhuanli">
                     <span></span> 
                    <span>专利：</span> 
                    <span>10项</span> 
                    <span class="ml8">商标：</span> 
                    <span>--</span> 
                    <span class="ml8">已获补贴：</span> 
                    <span>10项</span> 
                    <span class="ml8">补贴金额：</span> 
                    <span>10万元</span>
                   </p>
                   <p v-if="item.historyName!=null&&item.historyName!=''" class="pnomp z2_infos ellipsis">
                     <span></span> 
                    <span>曾用名：</span> 
                    <span>{{item.historyName}}</span> 
                 
                   </p>
                    <p class="pnomp z2_infos ellipsis">
                     <span>经营范围：</span
                     ><span :title="item.businessScope">{{
                       item.businessScope
                     }}</span>
                   </p> 
                   <!-- <p class="pnomp z2_infos ellipsis">
                     <span>涉及产业：</span
                     ><span class="textbl" :title="item.industryName">{{
                       item.industryName
                     }}</span>
                   </p> -->
                 </div>
                 </el-col>
             </el-row>
      <div class="fenye" v-if="totalPassSY!=0">
        <PaginationCom :totalPass="totalPassSY" :currentPagePass="currentPagePassSY" @handleCurrentChangeBack="handleCurrentChangeBackSY" :backgroundPass="true" :layoutPass="'prev, pager, next'"></PaginationCom>
      </div>
    </div>
  </div>
</template>
<script>
import companytab from '../../../components/map/companytab'
// import {enterprisePageList,enterpriseSearchName} from '../../../api/map/common'
import {enterprisePageList,enterpriseSearchName} from "../../../request/moudle/map/common"


import PaginationCom from '../../../components/zkwl/PaginationCom/PaginationCom.vue'
import FangziHeadTwo from "../../../components/zkwl/FangziHeadTwo.vue";
export default {
  name: "face",
  data(){
    return {
      totalPassSY:0,
      currentPagePassSY:1,
      currentPageSize:10,
      keyword:'',
      gridDataShangyou:[],
      //
      state: '',
      timeout: null,
      suggestions: [],
      isLoading:false,
      //
      // pageNo:1,
      // total:60
    }
  },
  created() {
    // this.$store.commit("CHANGE_TABTYPE", 0);
    // this.$bus.$on("refresh_Huaxiang", (val) => {
	  //     console.log(val)   // 0.7022180283884656
    //     // this.$message.error('跳转');
    //     // this.initPage();
    //     const obj = sessionStorage.getItem("parampass_huaxiang");
    // console.log("企业参数", obj);
    // if (obj == undefined) {
    //   this.getSYList();
    // } else {
    //   // this.ss_companypg = JSON.parse(obj);
    //   const info=JSON.parse(obj);
    //   this.state=info.key;
    //   this.getSYList();
    // }
	  //   });
  },
  mounted(){
    const obj = sessionStorage.getItem("parampass_huaxiang");
    console.log("企业参数", obj);
    if (obj == undefined) {
      this.getSYList();
    } else {
      // this.ss_companypg = JSON.parse(obj);
      const info=JSON.parse(obj);
      this.state=info.key;
      this.getSYList();
    }

  },
  components:{
    companytab,
    PaginationCom,
    FangziHeadTwo,
  },
  methods:{
    // goxq(idP) {
      // sessionStorage.removeItem("parampass_companyxq");
      // sessionStorage.setItem(
      //   "parampass_companyxq",
      //   JSON.stringify({ id: idP })
      // );
      // this.$router.push({
      //   path: "/map/companyxq",
      // });
    // },
    //去外部地址
    gotoWOff(val) {
      if (val != "") {
        // window.open(val,"_blank");
        window.open("https://www.baidu.com", "_blank");
      }
    },
    btnSearch(){
      this.gridDataShangyou=[];
   
      this.currentPagePassSY=1;
      this.getSYList();
    },
    querySearch(queryString, cb) {
      const that=this;
      // 清除定时器
      clearTimeout(this.timeout);
      if(that.state==''){
        return;
      }
      this.timeout = setTimeout(() => {
        // 模拟从后台获取数据的异步操作
        enterpriseSearchName({key:queryString}).then(res=>{
      
          const names=res.data.map(item=>{
            return {value:item.name,id:item.id} ;
          })
            that.suggestions = names;
      //       // 调用 callback 返回建议列表的数据
            cb(that.suggestions);
        }).catch(err=>{
          cb([]);
        });
      }, 500); // 延迟200毫秒请求，防止密集的请求
      // this.timeout = setTimeout(() => {
      //   // 模拟从后台获取数据的异步操作
      //   axios.get('your-api-url', { params: { q: queryString } })
      //     .then(response => {
      //       // 假设返回的数据格式为 { data: ['Option 1', 'Option 2', ...] }
      //       this.suggestions = response.data.data;
      //       // 调用 callback 返回建议列表的数据
      //       cb(this.suggestions);
      //     })
      //     .catch(error => {
      //       console.error(error);
      //       cb([]);
      //     });
      // }, 200); // 延迟200毫秒请求，防止密集的请求
    },
    handleSelect(item) {
      // 选中某项时的处理逻辑
    },
    handleClear(){
      this.currentPagePassSY=1;
      this.getSYList();
    },
    //搜索按钮
    btnEnts(){
      this.currentPagePassSY=1;
      this.getSYList();
    },
    shuffleArray(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const randomIndex = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[randomIndex]] = [arr[randomIndex], arr[i]];
  }
  return arr;
},
        //获取上游列表
        getSYList(){
     let query={...{size:this.currentPageSize,current:this.currentPagePassSY}}
          this.isLoading=true;
     enterprisePageList({...{key:this.state},...query}).then(res=>{
      this.isLoading=false;
      //  const res2=res.data.data;
      // this.gridDataShangyou=res2.records;
      // this.totalPassSY=res2.total;
      debugger;
      let clsYs=['rgb(225, 165, 62)','rgb(94, 200, 196)','rgb(242, 197, 86)','rgb(237, 119, 119)','rgb(133, 196, 157)','rgb(141, 149, 254)','rgb(254, 145, 145)','rgb(91, 154, 255)','rgb(147, 112, 219)','rgb(205, 155, 155)'];
          let cls=this.shuffleArray(clsYs);
          this.isLoading = false;
          const res2 = res.data;
          this.gridDataShangyou = res2.records.map((item,index) => {
            return {
              ...item,
              ...{clCaihong:cls[index]},
              ...{
                labelList:
                  item.labelList.length == 0
                    ? ["中小型优质企业"]
                    : item.labelList,
              },
            };
          });
          this.totalPassSY = res2.total;
     }).catch(err=>{
      this.isLoading=false;
     });
   },
        //当前页发生变化
        handleCurrentChangeBackSY(val){
this.currentPagePassSY=val;
this.getSYList();
},
    goxq(idP){
      // sessionStorage.removeItem('parampass_companyxq');
        // sessionStorage.setItem('parampass_companyxq',JSON.stringify({id:idP}));
      this.$router.push({path: "/companyxq",query:{
        id:idP
      }});
    }
  }
}
</script>
<style lang="scss" scoped>
.huaxiang{
  font-size: 14px;
  background: url("../../../assets/img/map/sousuo.jpg");
  /* //将图片样式不重复 */
  background-repeat: no-repeat;
  /* //设置图片大小 */
  // background-size: 100%;
    position: relative;
    background-size:100% 100%;
    min-height: calc( 100vh - 120px);
}
.list{
  padding: 17px 10px;
  border-bottom: 1px solid #DFDFDF;
  font-size: 12px;
  .h1{
    font-weight: 550;
    line-height: 26px;
    font-size:14px;
  }
}
.fenye{
  text-align: center;
  padding: 30px 0 0 0;
}
.companys{
  /deep/ .el-row:hover {
  background-color: #eceff6; /* 高亮颜色 */
}
}
.z2_contents {

.z2_infos {
  // font-size: 12px;
  font-size:14px;
  color: #6d6d6e;
  line-height: 24px;
}
.textml {
  margin-right: 12px;
}
.textml2 {
  margin-left: 43px;
}
.textbl {
  color: #007af3;
}
.textgr {
  color: #3abc86;
  border: 1px solid #3abc86;
  padding: 0px 3px;
  border-radius: 3px;
}
.pname {
  // font-weight: bold;
  font-size: 18px;
cursor: pointer;
color: #292a2d;
line-height: 28px;
font-weight: 700;
margin-right: 6px;
max-width: 830px;
}
.pline {
  line-height: 25px;
}
.texttag {
  padding: 3px 10px;
  background-color: #e3f3ff;
}
.gw {
  cursor: pointer;
}
}
.activeZ {
color: #007af3;
}
</style>
